import { observable } from "@legendapp/state";
import { ObservablePersistLocalStorage } from "@legendapp/state/persist-plugins/local-storage";
import { synced } from "@legendapp/state/sync";

export const lastVisitedBoardId$ = observable(
  synced<string | null>({
    initial: null,
    persist: {
      name: "lastVisitedBoardId",
      plugin: ObservablePersistLocalStorage,
    },
  }),
);
